"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.LogLevel = void 0;
const Exports_js_1 = require("../common/Exports.js");
Object.defineProperty(exports, "LogLevel", { enumerable: true, get: function () { return Exports_js_1.EventType; } });

//# sourceMappingURL=LogLevel.js.map
